// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nBNr","content":"styles_content__3fOhW"};